import { createAnalyticsGroup } from 'js/lib/analytics'

const banner = document.querySelector('.js-c-banner_love-knows-no-breed')

if (banner) {
  const trackingGroup = banner.getAttribute('data-tracking-group') || 'default_group'
  const track = createAnalyticsGroup(`lknb_campaign_banner_${trackingGroup}`)
  const ctaButton = banner.querySelector('.js-c-banner_love-knows-no-breed--cta')

  if (ctaButton) { 
    ctaButton.addEventListener('click', () => { 
      track('click', 'cta button')
    })
  }
}
